export enum BillType {
    SCHEDULED = 'SCHEDULED',
    ON_DEMAND = 'ON_DEMAND',
}
